import React, { useEffect, useRef } from "react";

const TradingViewWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    new window.TradingView.widget({
      container_id: "tradingview_chart",
      autosize: true,
      symbol: "ETHUSD", // Change to your desired symbol
      interval: "1", // Timeframe: 1D, 1H, etc.
      theme: "dark", // Light or dark theme
      style: "1",
      locale: "en",
      toolbar_bg: "#f1f3f6",
      enable_publishing: false,
      hide_side_toolbar: false,
      allow_symbol_change: true,
      details: true,
    });
  }, []);

  return (
    <div
      id="tradingview_chart"
      ref={widgetRef}
      style={{ height: "400px", width: "100%" }}
    ></div>
  );
};

export default TradingViewWidget;
